//Default Checkboxs
export const DEFAULT_CHECKBOX = [
  {
    text: "Use the ",
    code: ".form-check-input ",
  },
  {
    text: "and ",
    code: ".form-check-label ",
  },
  {
    text: "for checkbox.",
  },
];

export const DEFAULT_CHECKBOX_LIST = [
  {
    title: "Disabled Checks",
    span: [
      {
        id: "flexCheckDefault1",
        label: "Disabled checkbox",
        disabled: true,
      },
      {
        id: "flexCheckChecked2",
        label: "Disabled checked checkbox",
        disabled: true,
        defaultChecked: true,
      },
    ],
  },
  {
    title: "Right Checks",
    className: "form-check-reverse",
    span: [
      {
        id: "reverseCheck1",
        label: "Reverse checkbox",
      },
      {
        id: "reverseCheck2",
        label: "Disabled reverse checkbox",
        disabled: true,
        defaultChecked: true,
      },
    ],
  },
];

//Custom Checkbox
export const CUSTOM_CHECKBOX = [
  {
    text: "Use the ",
    code: ".form-check-input ",
  },
  {
    text: "and ",
    code: ".form-check-label ",
  },
  {
    text: "for checkbox. And filled checkbox used ",
    code: ".checkbox-solid-*",
  },
  {
    text: " and bordered checkbox used ",
    code: ".checkbox-*",
  },
];

//Bordered Checkbox
export const BORDERED_CHECKBOX = [
  {
    color: "secondary",
    text: "Secondary - checkbox-secondary",
  },
  {
    color: "success",
    text: "Success - checkbox-secondary",
  },
];

//Icon Checkbox
export const CUSTOM_CHECKBOX_LIST = [
  {
    id: 1,
    icon: "user",
    text: "User",
    defaultChecked: true,
  },
  {
    id: 2,
    icon: "tags",
    text: "Tags",
  },
  {
    id: 3,
    icon: "android",
    text: "Android",
  },
  {
    id: 4,
    icon: "slash",
    text: "Hidden",
  },
  {
    id: 5,
    icon: "folder-open",
    text: "Folder",
  },
  {
    id: 6,
    icon: "paper-plane",
    text: "Send",
  },
  {
    id: 7,
    icon: "cloud-upload",
    text: "Upload",
  },
];

//Filled Checkbox
export const FILL_CHECKBOX_LIST = [
  {
    id: 1,
    text: "Danger - checkbox-solid-danger",
    color: "danger",
  },
  {
    id: 2,
    text: "Info - checkbox-solid-info",
    color: "info",
  },
];

//Default Radio
export const DEFAULT_RADIO = [
  {
    text: "Use the ",
    code: ".form-check-input ",
  },
  {
    text: "and ",
    code: ".form-check-label ",
  },
  {
    text: "for radios.",
  },
];

export const DEFAULT_RADIO_LIST = [
  {
    title: "Disabled Radios",
    span: [
      {
        id: "flexRadioDisabled",
        label: "Disabled radio",
        disabled: true,
      },
      {
        id: "flexRadioCheckedDisabled",
        label: "Disabled checked radio",
        disabled: true,
        defaultChecked: true,
      },
    ],
  },
  {
    title: "Right Radios",
    className: "form-check-reverse",
    span: [
      {
        id: "flexRadioDefault3",
        label: "Default radio",
      },
      {
        id: "flexRadioCheckedDisabled1",
        label: "Disabled checked radio",
        disabled: true,
        defaultChecked: true,
      },
    ],
  },
];

//Images With Checkbox
export const IMAGE_WITH_CHECKBOX = [
  {
    text: "Use the ",
    code: ".form-check-input ",
  },
  {
    text: "and ",
    code: ".form-check-label ",
  },
  {
    text: "for image checkbox.",
  },
];

export const IMAGE_WITH_CHECKBOX_LIST = [
  {
    id: "img-check-2",
    src: "2",
    label: "Checked Image",
    defaultChecked: true,
    alt: "tree",
  },
  {
    id: "img-check-3",
    src: "3",
    label: "Disable Image",
    disabled: true,
    alt: "flowers",
  },
  {
    id: "img-check-4",
    src: "4",
    label: "Disable Checked Image",
    alt: "rose-tea",
    disabled: true,
    defaultChecked: true,
  },
];

//Images With Radio
export const IMAGE_WITH_RADIO = [
  {
    text: "Use the ",
    code: ".form-check-input ",
  },
  {
    text: "and ",
    code: ".form-check-label ",
  },
  {
    text: "for image radio.",
  },
];

export const IMAGE_WITH_RADIO_LIST = [
  {
    id: "img-radio-2",
    src: "6",
    label: "Checked Image",
    defaultChecked: true,
    alt: "tree",
  },
  {
    id: "img-radio-3",
    src: "7",
    label: "Disable Image",
    disabled: true,
    alt: "flowers",
  },
  {
    id: "img-radio-4",
    src: "8",
    label: "Disable Checked Image",
    alt: "rose-tea",
    disabled: true,
    defaultChecked: true,
  },
];

//Custom Radios
export const CUSTOM_RADIO = [
  {
    text: "Use the ",
    code: ".form-check-input ",
  },
  {
    text: "and ",
    code: ".form-check-label ",
  },
  {
    text: "for radios.",
  },
];

//Bordered Radio
export const BORDERED_RADIO = [
  {
    id: "radio55",
    color: "success",
    text: "Roxo Theme ",
  },
  {
    id: "radio33",
    color: "warning",
    text: "Voxo Theme",
  },
  {
    id: "radio66",
    color: "info",
    text: "Zeta Theme",
  },
];

//Icon Radio
export const CUSTOM_RADIO_LIST = [
  {
    id: 1,
    icon: "eye-slash",
    text: "Hidden",
    defaultChecked: true,
  },
  {
    id: 2,
    icon: "folder-open",
    text: "Folder",
  },
  {
    id: 3,
    icon: "paper-plane",
    text: "Send",
  },
  {
    id: 4,
    icon: "user",
    text: "User",
  },
  {
    id: 5,
    icon: "trash-o",
    text: "Trash",
  },
  {
    id: 6,
    icon: "github",
    text: "Github",
  },
  {
    id: 7,
    icon: "play-circle",
    text: "Play",
  },
];

//Filled Radio
export const FILL_RADIO_LIST = [
  {
    id: 1,
    text: "Order history",
    color: "warning",
  },
  {
    id: 2,
    text: "Invoice",
    color: "danger",
  },
  {
    id: 3,
    text: "Wishlist",
    color: "info",
  },
];

//Default Switches
export const DEFAULT_SWITCH = [
  {
    text: "Use the ",
    code: ".form-switch",
  },
  {
    text: " and ",
    code: ".form-check-label ",
  },
  {
    text: "for switches.",
  },
];

export const DEFAULT_SWITCH_LIST = [
  {
    title: "Disabled Switches",
    span: [
      {
        id: "flexSwitchCheckDisabled",
        label: "Disabled switch checkbox input",
        disabled: true,
      },
      {
        id: "flexSwitchCheckCheckedDisabled",
        label: "Disabled checked switch checkbox input",
        disabled: true,
        defaultChecked: true,
      },
    ],
  },
  {
    title: "Right Switches",
    className: "form-check-reverse",
    inputClass: "ms-2",
    span: [
      {
        id: "flexSwitchCheckReverse",
        label: "Reverse switch checkbox input",
      },
      {
        id: "flexSwitchCheckDisabled1",
        label: "Disabled switch checkbox input",
        disabled: true,
        defaultChecked: true,
      },
    ],
  },
];

//Inline InputType
export const INLINE_INPUT = [
  {
    text: "Group checkboxes or radios on the same horizontal row by adding ",
    code: ".form-check-inline ",
  },
  {
    text: "to any",
    code: ".form-check.",
  },
];

export const INLINE_CHECHBOX = [
  {
    id: "inlineCheckbox2",
    text: "II",
  },
  {
    id: "inlineCheckbox3",
    text: "III (disabled)",
    disabled: true,
  },
];

export const INLINE_RADIO = [
  {
    id: "inlineRadio2",
    text: "2",
  },
  {
    id: "inlineRadio3",
    text: "3 (disabled)",
    disabled: true,
  },
];

export const INLINE_SWITCHES = [
  {
    id: "flexSwitchCheckDefault3",
  },
  {
    id: "flexSwitchCheckDisabled3",
    disabled: true,
  },
];

//Animated Buttons
export const ANIMATED_BUTTON = [
  {
    text: "Use the ",
    code: ".radio_animated ",
  },
  {
    text: "through animated checkbox and radios.",
  },
];

export const ANIMATED_PAYMENT = [
  {
    id: "edo-ani1",
    text: "MasterCard",
  },
  {
    id: "edo-ani2",
    text: "Paypal",
    defaultChecked: true,
  },
  {
    id: "edo-ani13",
    text: "G-pay",
  },
  {
    id: "edo-ani6",
    text: " Bitpay",
  },
];

export const ANIMATED_SOCIAL = [
  {
    id: "chk-ani1",
    text: "Facebook",
  },
  {
    id: "chk-ani2",
    text: "Whatsapp",
    defaultChecked: true,
  },
  {
    id: "chk-ani4",
    text: "Twitter",
  },
];

//Basic Radio And Checkbox
export const BASIC_RADIO_CHECKBOX = [
  {
    text: "Use the ",
    code: ".form-check-input ",
  },
  {
    text: "through display inline.",
  },
];

export const BASIC_RADIO_CHECKBOX_LIST = [
  {
    id: "inline-2",
    text: "Gallery",
    defaultChecked: true,
  },
  {
    id: "inline-3",
    text: "Faq",
  },
  {
    id: "inline-4",
    text: "Email",
  },
  {
    id: "inline-5",
    text: "Icons",
  },
];

export const BASIC_RADIO_CHECKBOX_DATA = [
  {
    id: "radioinline2",
    text: "Tasks",
  },
  {
    id: "radioinline3",
    text: " To-do",
  },
  {
    id: "radioinline4",
    text: "Forms",
  },
  {
    id: "radioinline5",
    text: "Login",
  },
];

//Radio Toggle Buttons
export const RADIO_TOGGLE = [
  {
    text: "The choice between these two approaches will depend on the type of toggle you are creating, and whether or not the toggle will make sense to users when announced as a checkbox or as an actual button. ",
    code: "[any one selected].",
  },
];

export const RADIO_TOGGLE_LIST = [
  {
    id: "option2",
    text: "Radio",
  },
  {
    id: "option3",
    text: "Disabled",
    disabled: true,
  },
  {
    id: "option4",
    text: "Radio",
  },
];

//Outlined Checkbox Styles
export const OUTLINE_CHECKBOX = [
  {
    text: "The choice between these two approaches will depend on the type of toggle you are creating, and whether or not the toggle will make sense to users when announced as a checkbox or as an actual button. ",
    code: "[multiple selected].",
  },
];
